import { english as commonEnglish } from '~frontend-common/i18n/english';

const keys = {
  // TODO: these translations should be shared across applications, they are needed by errorToMessageId in SentryErrorBox
  error: {
    invalidCredentials: 'Wrong username and/or password combination, please try again.',
    clientNotFound: "We're having some connectivity problems. Please try again.",
    clientUnauthorized: "We're having some connectivity problems. Please try again.",
    clientRequestInvalid: "We're having some connectivity problems. Please try again.",
    serverUnreachable: "We're having some connectivity problems. Please try again.",
    serverError: "We're having some connectivity problems. Please try again.",
    serverTimeout: "We're having some connectivity problems. Please try again.",
    unknownError: "We're having some connectivity problems. Please try again.",

    // TODO: this is for the 404 component, needs refactoring and using namespaces
    ...commonEnglish.error,
  },
};

export default keys;

export type TranslationKeys = typeof keys;
